<div class="arcade-shell">
	<div class="arcade-marquee" aria-hidden="true">
		<span class="marquee-text">{{ title }}</span>
	</div>

	<div
		class="game-container"
		#gameContainer
		tabindex="0"
		role="application"
		aria-label="Phil Invaders arcade game"
		[class.is-playing]="isPlaying"
		(keydown)="onKeyDown($event)"
		(keyup)="onKeyUp($event)"
	>
		<div class="starfield" aria-hidden="true">
			<span class="star star-1"></span>
			<span class="star star-2"></span>
			<span class="star star-3"></span>
			<span class="star star-4"></span>
			<span class="star star-5"></span>
			<span class="star star-6"></span>
		</div>

		<div class="playfield">
			<header class="hud">
				<div class="hud-block">
					<span class="hud-label">Score</span>
					<span class="hud-value">{{ score }}</span>
				</div>
				<div class="hud-block hud-center">
					<span class="hud-label">Round</span>
					<span class="hud-value">{{ round }}</span>
				</div>
				<div class="hud-block hud-right">
					<span class="hud-label">Fleet</span>
					<span class="hud-value">{{ enemies.length }}</span>
				</div>
			</header>

			<div
				class="player-ship"
				[class.player-ship--hit]="gameState === 'gameOver'"
				[style.left.%]="playerPosition"
				aria-hidden="true"
			>
				<span class="ship-body"></span>
				<span class="ship-cockpit"></span>
				<span class="ship-wing ship-wing--left"></span>
				<span class="ship-wing ship-wing--right"></span>
			</div>

			<div
				class="player-bullet"
				*ngFor="let bullet of bullets; trackBy: trackById"
				[style.left.%]="bullet.left"
				[style.top.%]="bullet.top"
				aria-hidden="true"
			></div>

			<div
				class="enemy-bullet"
				*ngFor="let bullet of enemyBullets; trackBy: trackById"
				[style.left.%]="bullet.left"
				[style.top.%]="bullet.top"
				aria-hidden="true"
			></div>

			<div
				class="invader invader--type-{{ enemy.type }}"
				[class.invader--alt]="invaderFrame === 1"
				*ngFor="let enemy of enemies; trackBy: trackById"
				[style.left.%]="enemy.left"
				[style.top.%]="enemy.top"
				aria-hidden="true"
			>
				<span class="invader-eye invader-eye--left"></span>
				<span class="invader-eye invader-eye--right"></span>
				<span class="invader-antenna"></span>
			</div>

			<div
				class="explosion"
				*ngFor="let burst of explosions; trackBy: trackById"
				[style.left.%]="burst.left"
				[style.top.%]="burst.top"
				aria-hidden="true"
			></div>

			<div class="overlay" *ngIf="showOverlay">
				<div class="overlay-card" [class.overlay-card--danger]="gameState === 'gameOver'">
					<h2 class="overlay-title">{{ overlayTitle }}</h2>
					<p class="overlay-score" *ngIf="gameState !== 'idle'">Score: {{ score }}</p>
					<p class="overlay-action">{{ overlayAction }}</p>
					<button type="button" class="overlay-button" (click)="onPrimaryAction()">
						{{ gameState === 'idle' ? 'Start' : gameState === 'roundCleared' ? 'Continue' : 'Restart' }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<div class="touch-controls" aria-label="Touch controls">
		<button
			type="button"
			class="touch-button touch-button--left"
			aria-label="Move left"
			(touchstart)="onTouchLeft(true); $event.preventDefault()"
			(touchend)="onTouchLeft(false)"
			(touchcancel)="onTouchLeft(false)"
			(mousedown)="onTouchLeft(true)"
			(mouseup)="onTouchLeft(false)"
			(mouseleave)="onTouchLeft(false)"
		>
			◀
		</button>
		<button type="button" class="touch-button touch-button--fire" aria-label="Fire" (click)="onTouchFire()">
			FIRE
		</button>
		<button
			type="button"
			class="touch-button touch-button--right"
			aria-label="Move right"
			(touchstart)="onTouchRight(true); $event.preventDefault()"
			(touchend)="onTouchRight(false)"
			(touchcancel)="onTouchRight(false)"
			(mousedown)="onTouchRight(true)"
			(mouseup)="onTouchRight(false)"
			(mouseleave)="onTouchRight(false)"
		>
			▶
		</button>
	</div>

	<p class="control-hint">
		Arrows or A/D to move • Space or Fire to shoot • Enter to start, continue, or restart
	</p>
</div>
